import { X } from "lucide-react";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

interface BulkBarProps {
  count: number;
  onExport: () => void;
  onClear: () => void;
}

export function BulkBar({ count, onExport, onClear }: BulkBarProps): JSX.Element | null {
  const { t } = useTranslation("orders");

  if (count === 0) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 z-40 flex -translate-x-1/2 items-center gap-4 rounded-2xl bg-[var(--text-primary)] px-4 py-2.5 pl-5 text-white shadow-[var(--sh-pop)]"
      data-testid="bulk-bar"
    >
      <span className="text-[13.5px] font-bold">{t("sel_count", { n: count })}</span>
      <span className="h-5 w-px bg-white/20" />
      <button
        type="button"
        onClick={onExport}
        className="inline-flex h-8 items-center gap-1.5 rounded-lg bg-white/10 px-3 text-[13px] font-semibold transition hover:bg-white/20"
        aria-label={t("bulk_export")}
      >
        {t("bulk_export")}
      </button>
      <button
        type="button"
        onClick={onClear}
        aria-label={t("bulk_clear")}
        className="grid h-8 w-8 place-items-center rounded-lg bg-white/10 transition hover:bg-white/20"
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
}
